<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">我的消息</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div>
                <mt-navbar class="page-part" v-model="selected">
                    <mt-tab-item id="1">通知</mt-tab-item>
                    <mt-tab-item id="2">活动</mt-tab-item>
                </mt-navbar>
                <mt-tab-container v-model="selected">
                    <mt-tab-container-item id="1">
                        <ul class="inform" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                            <li v-for="(value,index) in messageList" :key="index" @click="goMessageInfo(value.msgId, value.type)">
                                <img src="../../assets/images/inviteIcon.png" alt="">
                                <span>{{ value.senderName }}</span>
                                <span>{{ value.sendTime | moment('YYYY年MM月DD日 HH:mm') }}</span>
                                <span>{{ value.subject }}</span>
                                <img class="vipLogo" v-if="isVip" src="../../assets/images/vipLogo.png" alt="">
                                <i class="el-icon-arrow-right"></i>
                                <i class="redPoint" v-if="value.isRead == 0"></i>
                            </li>
                        </ul>
                    </mt-tab-container-item>
                    <mt-tab-container-item id="2">
                        <ul class="activity">
                            <li>
                                <img src="../../assets/images/discountIcon.png" alt="">
                                <span>优惠券到账提醒</span>
                                <span>今天05：30</span>
                                <span>“上林时光（上街店）”送您一....</span>
                                <img class="vipLogo" v-if="isVip" src="../../assets/images/vipLogo.png" alt="">
                                <i class="el-icon-arrow-right"></i>
                                <i class="redPoint" v-if="!haveRead"></i>
                            </li>
                            <li>
                                <img src="../../assets/images/activityIcon.png" alt="">
                                <span>活动提醒</span>
                                <span>今天05：30</span>
                                <span>“上林时光（上街店）”发布新....</span>
                                <img class="vipLogo" v-if="isVip" src="../../assets/images/vipLogo.png" alt="">
                                <i class="el-icon-arrow-right"></i>
                                <i class="redPoint" v-if="!haveRead"></i>
                            </li>
                        </ul>
                    </mt-tab-container-item>
                </mt-tab-container>
            </div>
        </div>
    </div>
</template>
<script>
import bottom from "../footerTo/bottom";
import { DatetimePicker, Popup, Toast, Indicator, Radio, Navbar, TabItem } from "mint-ui";
import { showMsgListAction } from "@/assets/js/api";

export default {
  data() {
    return {  
        isFront:false, 
        isVip:false,
        haveRead:false,
        selected:'1',
        beginIdx:0,                  // 分页的开始值
        num:0,                       // 分页几次
        messageList:[],              // 消息列表信息
        loading:true,                // 是否加载
        instance:Toast({
            message: '加载中....',
            position: 'middle',
            duration:-1
        }),
    };
  },
  computed: {},
  components: {},
  methods: { 
      // 跳转到消息详情
      goMessageInfo(msgId, type)
      {
        //   this.haveRead = true;
          console.log('msgId',msgId, 'type', type);
          this.$router.push({
              name:"paySuccessDetail",
              query:
              {
                msgId: msgId,
                type: type
              }
          });
      },
      checkHttpReturn(id){
          if(httpSendQue[id]==0)
          {
               
               var  self=this;
              setTimeout(() => {
                      if (self && !self._isDestroyed)
                          self.checkHttpTimeOut();
                  }, newConfigTime);

          }
          else
          {
              delete httpSendQue[id];
          }
      },
      checkHttpTimeOut()
      {
           console.log('222222222');
          if(httpSendQue[id]==0)
          {
              //  隐藏加载中
               this.instance.close()
               this.$vux.toast.show
              ({
                  type: 'warn',
                  position: 'center',
                  text: '请求超时'
              })   

          }
          else
          {
              //删除数组中的id
              delete httpSendQue[id];

          }
      },
      loadMore()
      {
          console.log('haohoahaohoa');
          this.getMessageList();
      },
      // 获取消息列表
      getMessageList()
      {
          //  获取商户消息通知列表 
          var maxRows = 10 ;
          if (this.num !== 0)
          {
              this.beginIdx = maxRows*this.num;
          }
          console.log('num',this.num);
          console.log('beginIdx',this.beginIdx);
          this.num ++;
         
          showMsgListAction(this.beginIdx, maxRows, {'type': '-1', 'isRead': '-1', 'isRemove': '0'}).then(res => {   
              this.instance.close();   
              if(res.s==0)
              {
                  console.log(res);
                  this.loading = false;              // 执行加载

                  if (this.messageList)
                  {
                      // 存入新获取的商品列表数据
                      res.msg.forEach((v,i)=> { this.messageList.push(v); })
                  }
                  else
                  {
                      this.messageList = res.msg;
                  }

                  //this.messageList = res.MessageList;
                  console.log("messageList",this.messageList);

                  if (res.msg.length < maxRows)
                  {
                    this.loading = true;
                    //return false;
                  }
                  //this.$store.commit("GetShopMessageListBySid",res.list)
              }else if(res.s==1010){
                  this.loading = true;
                  if (this.messageList.length == 0)
                  {
                      this.havaMessage= false;
                  }
              }
           
          })
          // .catch(error => {    
          //     this.instance.close();
          //     httpSendQue[id] = 1; 
          //     this.$vux.toast.show
          //     ({
          //         type: 'warn',   
          //         position: 'center',
          //         text: tipNetworkFail
          //     })   
          // })
      }
  },
  mounted()
  {
      this.getMessageList();
  }

};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  /* background-color: rgba(241, 241, 241, 1); */
  height: auto;
  width: 100%;
}
.inform li,
.activity li{
    background-color: #fff;
    height: 1.42rem;
    width: 100%;
    border-top: 0.03rem solid rgba(0, 0, 0, 0.1);
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
    position: relative;
}
.inform li :nth-child(1),
.activity li :nth-child(1){
    width: 0.89rem;
    height: 0.89rem;
    position: absolute;
    top: 0.29rem;
    left: 0.37rem;
}
.inform li :nth-child(2),
.activity li :nth-child(2){
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.9);
    position: absolute;
    top: 0.37rem;
    left: 1.68rem;
}
.inform li :nth-child(3),
.activity li :nth-child(3){
    font-size: 0.26rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0.47rem;
    right: 1.11rem;
}
.inform li :nth-child(4),
.activity li :nth-child(4){
    font-size: 0.32rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0.9rem;
    left: 1.68rem;
}
.vipLogo{
    width: 0.26rem;
    height: 0.26rem;
    position: absolute;
    top: 0.95rem;
    left: 1rem;
}
.redPoint{
    display: block;
    border-radius: 50%;
    width: 0.26rem;
    height: 0.26rem;
    background-color: rgba(246, 34, 65, 1);
    position: absolute;
    top: 0.29rem;
    left: 1rem;
}
.el-icon-arrow-right {
    font-size: 0.42rem;
    color: rgba(16, 16, 16, 1);
    font-weight: 600;
    position: absolute;
    top: 0.5rem;
    right: 0.51rem;
}
</style>



// WEBPACK FOOTER //
// src/components/cardBag/message.vue